import React, { FC, ReactNode } from 'react';
import { AsComponentProps } from '../../types/module';

export interface NodeAsProps {
  as: AsComponentProps;
  children?: ReactNode;
  classNames?: string;
  id?: string;
}

export const NodeAs: FC<NodeAsProps> = ({
  as: Component = 'div',
  children,
  classNames,
  id,
  ...props
}) => {
  return (
    <Component className={classNames} id={id} {...props}>
      {children}
    </Component>
  );
};
